import { Logger } from './logger';
import type { LoggerConfig } from './types';

/**
 * Factory function to create a logger instance
 */
export function createLogger(config: LoggerConfig): Logger {
  return new Logger(config);
}
